import axios from './axios'
import qs from 'qs';
let baseUrl = '/api/inbound/';
/**
 *
 * 
 */
export default {
  //绑定、解绑采购记录
  unbindLogisticsInfo(data) {
    return axios.post(baseUrl + 'editRelationReturnLogisticsInfo', qs.stringify(data));
  },

  //查询入库记录
  list(data) {
    return axios.post(baseUrl + 'listAmazonInboundRecord', qs.stringify(data));
  },

  //新增编辑入库记录
  add(data) {
    return axios.post(baseUrl + 'addOrUpdateAmazonInboundRecord', qs.stringify(data));
  },

  //删除入库记录
  delete(data) {
    return axios.post(baseUrl + 'deleteAmazonInboundRecord', qs.stringify(data));
  },

  //批量退货
  batchReturn(data) {
    return axios.post(baseUrl + 'batchReturn', qs.stringify(data));
  }
}
